import { type ReactElement } from "react";
import { Stack, Skeleton } from "@citibox-panel/ui";

export function SkeletonDemo(): ReactElement {
  return (
    <Stack spacing={1}>
      <Skeleton width={240} />
      <Skeleton variant="rectangular" width={240} height={64} />
      <Skeleton variant="circular" width={40} height={40} />
    </Stack>
  );
}
